import { useRef, useState } from "react";
import Input from "../../UI/Input";
import classes from "./CryptoItemForm.module.css";

const CryptoItemForm = (props) => {
  const [amountIsValid, setAmountIsValid] = useState(true);

  const amountInputRef = useRef();

  const submitHandler = (event) => {
    event.preventDefault();

    const enteredAmount = amountInputRef.current.value;
    const enteredAmountNumber = +enteredAmount;

    if (
      enteredAmount.trim().length === 0 ||
      enteredAmountNumber < 1 ||
      enteredAmountNumber > 50
    ) {
      setAmountIsValid(false);
      return;
    }

    props.onAddToCart(enteredAmountNumber);
  };

  return (
    <form className={classes.form} onSubmit={submitHandler}>
      <Input
        ref={amountInputRef}
        label="Aantal"
        input={{
          id: "amount_" + props.id,
          type: "number",
          min: "1",
          max: "50",
          step: "1",
          defaultValue: "1",
        }}
      />
      <button>+ Toevoegen</button>
      {!amountIsValid && <p>Vul een geldige hoeveelheid in (1-50).</p>}
    </form>
  );
};

export default CryptoItemForm;